import React from "react";
import moment from "moment";
import { humanisetime } from "../utils/formatters";
import { humanizeBytes } from "../utils/common";
import { GOOD_SYSTEM_BUILD_VERSION } from "./schoolData";

export const getClassName = (dataState) => {
  if (dataState === 0) {
    return "bg-cell-success";
  } else if (dataState === 2) {
    return "bg-cell-danger";
  } else {
    return "bg-cell-warning";
  }
};

export const getOverAllStatus = (dataState) => {
  if (dataState > 4) {
    return "bg-cell-danger";
  } else if (dataState > 1) {
    return "bg-cell-warning";
  } else {
    return "bg-cell-success";
  }
};

export const TABLE = [
  {
    title: "",
    dataIndex: "stat",
    key: "stat",
    isSelected: true,
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: (a, b) => a?.name?.localeCompare(b?.name),
    isSelected: true,
  },
  {
    title: "Role",
    dataIndex: "role",
    key: "role",
    sorter: (a, b) => a?.role?.localeCompare(b?.role),
    isSelected: true,
  },
  {
    title: "Login Id",
    dataIndex: "teacherMobile",
    key: "teacherMobile",
    sorter: (a, b) => a?.teacherMobile.localeCompare(b?.teacherMobile),
    align: "center",
    isSelected: true,
  },
  {
    title: "TPS Device ID",
    dataIndex: "mdmDeviceId",
    key: "mdmDeviceId",
    sorter: (a, b) => a?.mdmDeviceId?.localeCompare(b?.mdmDeviceId),
    isSelected: true,
    fixed: 'left'
  },
  {
    title: "Last Updated At",
    dataIndex: "lastTimestamp",
    key: "lastTimestamp",
    sorter: (a, b) => a?.lastTimestamp.localeCompare(b?.lastTimestamp),
    render: (lastTimestamp, data) => (
      <div className={getOverAllStatus(data?.overallstatus)}>
        {humanisetime(moment.utc(lastTimestamp).local())}
      </div>
    ),
    align: "center",
    isSelected: true,
  },
  {
    title: "App Version",
    dataIndex: "appVersion",
    key: "appVersion",
    className: (record) => getClassName(record?.appVersionStatus),
    sorter: (a, b) => a?.appVersion.localeCompare(b?.appVersion),
    render: (appVersion, data) => (
      <div className={getClassName(data?.appVersionStatus)}>{appVersion}</div>
    ),
    align: "center",
    isSelected: true,
  },
  {
    title: "Update Stage",
    dataIndex: "triggeredFrom",
    key: "triggeredFrom",
    render: (triggeredFrom, data) => (
      <div className={getClassName(data.oneClickStatus)}>
        {triggeredFrom === "one_click" ? triggeredFrom : ""}
      </div>
    ),
    filters: [
      {
        text: "Blank",
        value: "0",
      },
      {
        text: "Content Persistence",
        value: "1",
      },
      {
        text: "One Click",
        value: "2",
      },
    ],
    onFilter: (value, record) => {
      if (value === "0" && !record.triggeredFrom) return true;
      else if (
        value === "1" &&
        record?.triggeredFrom === "content_persistence"
      ) {
        return true;
      } else if (value === "2" && record?.triggeredFrom === "one_click")
        return true;
    },
    isSelected: true,
  },
  {
    title: "Ext. Storage Permission",
    dataIndex: "canManageExternalStorage",
    key: "canManageExternalStorage",
    filters: [
      {
        text: "Blank",
        value: "0",
      },
      {
        text: "Success",
        value: "1",
      },
      {
        text: "Warning",
        value: "2",
      },
      {
        text: "Danger",
        value: "3",
      },
    ],
    onFilter: (value, record) => {
      const canManageExternalStorage =
        2 - parseInt(record.canManageExternalStorage) * 2;
      if (value === "0" && record.canManageExternalStorage === null)
        return true;
      else if (value === "1" && canManageExternalStorage === 0) {
        return true;
      } else if (value === "2" && canManageExternalStorage === 1) return true;
      else if (value === "3" && canManageExternalStorage === 2) return true;
    },
    render: (_, data) => (
      <div
        className={getClassName(
          2 - parseInt(data.canManageExternalStorage) * 2
        )}
      ></div>
    ),
    isSelected: false,
  },
  {
    title: "Developer Option",
    dataIndex: "developerOptionEnabled",
    key: "developerOptionEnabled",
    render: (_, data) => (
      <div
        className={getClassName(1 - parseInt(data.developerOptionEnabled) * 1)}
      ></div>
    ),
    filters: [
      {
        text: "Blank",
        value: "0",
      },
      {
        text: "Success",
        value: "1",
      },
      {
        text: "Warning",
        value: "2",
      },
      {
        text: "Danger",
        value: "3",
      },
    ],
    onFilter: (value, record) => {
      const developerOptionEnabled =
        1 - parseInt(record.developerOptionEnabled) * 1;
      if (
        value === "0" &&
        (record.developerOptionEnabled === null ||
          !record.developerOptionEnabled)
      )
        return true;
      else if (value === "1" && developerOptionEnabled === 0) {
        return true;
      } else if (value === "2" && developerOptionEnabled === 1) return true;
      else if (value === "3" && developerOptionEnabled === 2) return true;
    },
    isSelected: false,
  },
  {
    title: "Nas Conectivity",
    dataIndex: "nasStatus",
    key: "nasStatus",
    render: (_, data) => <div className={getClassName(data.nasStatus)}></div>,
    filters: [
      {
        text: "Blank",
        value: "0",
      },
      {
        text: "Success",
        value: "1",
      },
      {
        text: "Warning",
        value: "2",
      },
      {
        text: "Danger",
        value: "3",
      },
    ],
    onFilter: (value, record) => {
      if (value === "0" && (record.nasStatus === null || !record.nasStatus))
        return true;
      else if (value === "1" && record.nasStatus === 0) {
        return true;
      } else if (value === "2" && record.nasStatus === 1) return true;
      else if (value === "3" && record.nasStatus === 2) return true;
    },
    isSelected: true,
  },
  {
    title: "Resource Download",
    dataIndex: "resourceStatus",
    key: "resourceStatus",
    render: (_, data) => (
      <div className={getClassName(data.resourceStatus)}></div>
    ),
    filters: [
      {
        text: "Blank",
        value: "0",
      },
      {
        text: "Success",
        value: "1",
      },
      {
        text: "Warning",
        value: "2",
      },
      {
        text: "Danger",
        value: "3",
      },
    ],
    onFilter: (value, record) => {
      if (
        value === "0" &&
        (record?.resourceStatus === null || !record?.resourceStatus)
      )
        return true;
      else if (value === "1" && record?.resourceStatus === 0) {
        return true;
      } else if (value === "2" && record?.resourceStatus === 1) return true;
      else if (value === "3" && record?.resourceStatus === 2) return true;
    },
    isSelected: true,
  },
  {
    title: "Tab Performance SW",
    dataIndex: "mdmstate",
    key: "mdmstate",
    render: (_, data) => <div className={getClassName(data?.mdmstate)}></div>,
    filters: [
      {
        text: "Blank",
        value: "0",
      },
      {
        text: "Success",
        value: "1",
      },
      {
        text: "Warning",
        value: "2",
      },
      {
        text: "Danger",
        value: "3",
      },
    ],
    onFilter: (value, record) => {
      if (value === "0" && record?.mdmstate === null) return true;
      else if (value === "1" && record?.mdmstate === 0) {
        return true;
      } else if (value === "2" && record?.mdmstate === 1) return true;
      else if (value === "3" && record?.mdmstate === 2) return true;
    },
    isSelected: true,
  },
  {
    title: "Firmware Status",
    dataIndex: "systemBuildVersion",
    key: "systemBuildVersion",
    filters: [
      {
        text: "Blank",
        value: "0",
      },
      {
        text: "Good Firmware",
        value: "1",
      },
      {
        text: "Bad Firmware",
        value: "2",
      },
    ],
    onFilter: (value, record) => {
      if (
        value === "0" &&
        (!record?.systemBuildVersion || !record?.systemBuildVersion === null)
      ) {
        return true;
      } else if (
        value === "1" &&
        GOOD_SYSTEM_BUILD_VERSION.includes(record.systemBuildVersion)
      ) {
        return true;
      } else if (
        value === "2" &&
        !GOOD_SYSTEM_BUILD_VERSION.includes(record.systemBuildVersion)
      ) {
        return true;
      }
    },
    render: (_, data) => (
      <div className={getClassName(data.systemBuildVersionStatus)}></div>
    ),
    isSelected: false,
  },
  {
    title: "Total Resources",
    dataIndex: "totalResources",
    key: "totalResources",
    align: "center",
    sorter: (a, b) => a?.totalResources - b?.totalResources,
    filters: [
      {
        text: "Blank",
        value: "0",
      },
      {
        text: "Non Blank",
        value: "1",
      },
    ],
    onFilter: (value, record) => {
      if (
        value === "0" &&
        (!record.totalResources || record.totalResources === null)
      )
        return true;
      else if (value === "1" && record.totalResources) {
        return true;
      }
    },
    isSelected: false,
  },
  {
    title: "Red Resources",
    dataIndex: "redResources",
    key: "redResources",
    align: "center",
    sorter: (a, b) => a?.redResources - b?.redResources,
    isSelected: true,
  },
  {
    title: "Teacher Total Resources",
    dataIndex: "teacherTotalResources",
    key: "teacherTotalResources",
    align: "center",
    sorter: (a, b) => a?.teacherTotalResources - b?.teacherTotalResources,
    filters: [
      {
        text: "Blank",
        value: "0",
      },
      {
        text: "Non Blank",
        value: "1",
      },
    ],
    onFilter: (value, record) => {
      if (
        value === "0" &&
        (!record.teacherTotalResources || record.teacherTotalResources === null)
      )
        return true;
      else if (value === "1" && record.teacherTotalResources) {
        return true;
      }
    },
    isSelected: false,
  },
  {
    title: "Teacher Red Resources",
    dataIndex: "teacherRedResources",
    key: "teacherRedResources",
    align: "center",
    sorter: (a, b) => a?.teacherRedResources - b?.teacherRedResources,
    isSelected: true,
  },
  {
    title: "Persistence Run@",
    dataIndex: "contentPersistenceRunAt",
    key: "contentPersistenceRunAt",
    render: (contentPersistenceRunAt) => (
      <div>{humanisetime(contentPersistenceRunAt)}</div>
    ),
    sorter: (a, b) =>
      moment(a?.contentPersistenceRunAt).unix() -
      moment(b?.contentPersistenceRunAt).unix(),
    isSelected: true,
  },
  {
    title: "One Click Run@",
    dataIndex: "oneClickRunAt",
    key: "oneClickRunAt",
    sorter: (a, b) =>
      moment(a?.oneClickRunAt).unix() - moment(b?.oneClickRunAt).unix(),
    render: (oneClickRunAt) => <div>{humanisetime(oneClickRunAt)}</div>,
    isSelected: true,
  },
  {
    title: "Tech Book Enabled",
    dataIndex: "isTechBookEnabled",
    key: "isTechBookEnabled",
    sorter: (a, b) => a?.isTechBookEnabled?.localeCompare(b?.isTechBookEnabled),
    render: (isTechBookEnabled) => (
      <div className={getClassName(isTechBookEnabled === "Yes" ? 0 : 2)}>
        {isTechBookEnabled}
      </div>
    ),
    filters: [
      {
        text: "Yes",
        value: "Yes",
      },
      {
        text: "No",
        value: "No",
      },
    ],
    onFilter: (value, record) => record?.isTechBookEnabled === value,
    isSelected: true,
  },
  {
    title: "Tab Model",
    dataIndex: "tabModel",
    key: "tabModel",
    sorter: (a, b) => a?.tabModel - b?.tabModel,
    isSelected: true,
  },
  {
    title: "Tab Delivery Date",
    dataIndex: "tabDeliveryDate",
    key: "tabDeliveryDate",
    sorter: (a, b) => a?.tabDeliveryDate - b?.tabDeliveryDate,
    isSelected: true,
  },
  {
    title: "In Warranty",
    dataIndex: "inWarranty",
    key: "inWarranty",
    sorter: (a, b) => a?.inWarranty - b?.inWarranty,
    render: (inWarranty) => (
      <div className={getClassName(inWarranty === "Yes" ? 0 : 2)}>
        {inWarranty}
      </div>
    ),
    isSelected: true,
  },
  {
    title: "SD Card Size",
    dataIndex: "totalExternalStorage",
    key: "totalExternalStorage",
    align: "center",
    sorter: (a, b) => a?.totalExternalStorage - b?.totalExternalStorage,
    render: (totalExternalStorage) => (
      <div>{humanizeBytes(totalExternalStorage)}</div>
    ),
    isSelected: true,
  },
  {
    title: "Free Space in SD",
    dataIndex: "availableExternalStorage",
    key: "availableExternalStorage",
    align: "center",
    sorter: (a, b) => a?.availableExternalStorage - b?.availableExternalStorage,
    render: (availableExternalStorage) => (
      <div>{humanizeBytes(availableExternalStorage)}</div>
    ),
    isSelected: false,
  },
  {
    title: "SD Card Serial Number",
    dataIndex: "sdCardSerialNumber",
    key: "sdCardSerialNumber",
    sorter: (a, b) =>
      a?.sdCardSerialNumber?.localeCompare(b?.sdCardSerialNumber),
    filters: [
      {
        text: "Blank",
        value: "0",
      },
      {
        text: "Non Blank",
        value: "1",
      },
    ],
    onFilter: (value, record) => {
      if (
        value === "0" &&
        (!record.sdCardSerialNumber || record.sdCardSerialNumber === null)
      )
        return true;
      else if (value === "1" && record.sdCardSerialNumber) {
        return true;
      }
    },
    isSelected: false,
  },
  {
    title: "SD Card Version",
    dataIndex: "sdCardVersion",
    key: "sdCardVersion",
    sorter: (a, b) => a?.sdCardVersion?.localeCompare(b?.sdCardVersion),
    filters: [
      {
        text: "Blank",
        value: "0",
      },
      {
        text: "Non Blank",
        value: "1",
      },
    ],
    onFilter: (value, record) => {
      if (
        value === "0" &&
        (!record.sdCardVersion || record.sdCardVersion === null)
      )
        return true;
      else if (value === "1" && record.sdCardVersion) {
        return true;
      }
    },
    isSelected: false,
  },
  {
    title: "SD Card OK",
    dataIndex: "sdCardErrorMessage",
    key: "sdCardErrorMessage",
    render: (sdCardErrorMessage) => (
      <div className={getClassName(sdCardErrorMessage ? 2 : 0)}></div>
    ),
    filters: [
      {
        text: "Error",
        value: "0",
      },
      {
        text: "No Error",
        value: "1",
      },
    ],
    onFilter: (value, record) => {
      if (value === "0" && record?.sdCardErrorMessage) return true;
      else if (value === "1" && !record?.sdCardErrorMessage) return true;
    },
    isSelected: true,
  },
  {
    title: "Prepared Date",
    dataIndex: "preparedDate",
    key: "preparedDate",
    sorter: (a, b) =>
      moment(a?.preparedDate).unix() - moment(b?.preparedDate).unix(),
    filters: [
      {
        text: "Blank",
        value: "0",
      },
      {
        text: "Non Blank",
        value: "1",
      },
    ],
    onFilter: (value, record) => {
      if (
        value === "0" &&
        (!record.preparedDate || record.preparedDate === null)
      )
        return true;
      else if (value === "1" && record.preparedDate) {
        return true;
      }
    },
    isSelected: false,
  },
  {
    title: "NAS IP",
    dataIndex: "nasIpLastConnected",
    key: "nasIpLastConnected",
    sorter: (a, b) => a?.nasIpLastConnected - b?.nasIpLastConnected,
    filters: [
      {
        text: "Blank",
        value: "0",
      },
      {
        text: "Non Blank",
        value: "1",
      },
    ],
    onFilter: (value, record) => {
      if (
        value === "0" &&
        (!record.nasIpLastConnected || record.nasIpLastConnected === null)
      )
        return true;
      else if (value === "1" && record.nasIpLastConnected) {
        return true;
      }
    },
    isSelected: false,
  },
  {
    title: "Wi-Fi Name",
    dataIndex: "wifiName",
    key: "wifiName",
    sorter: (a, b) => a?.wifiName?.localeCompare(b?.wifiName),
    filters: [
      {
        text: "Blank",
        value: "0",
      },
      {
        text: "Lead AP",
        value: "1",
      },
      {
        text: "Unknown SSID",
        value: "2",
      },
      {
        text: "Not Detected",
        value: "3",
      },
    ],
    onFilter: (value, record) => {
      if (value === "0" && record.wifiName === null) return true;
      else if (
        value === "1" &&
        record?.wifiName?.toLowerCase().includes("lead ap")
      ) {
        return true;
      } else if (
        (value === "2" &&
          record?.wifiName?.toLowerCase().includes("unknown")) ||
        (value === "3" && record?.wifiName?.toLowerCase().includes("detected"))
      )
        return true;
    },
    isSelected: true,
  },
  {
    title: "Enrolled Time",
    dataIndex: "enrolledTime",
    key: "enrolledTime",
    sorter: (a, b) =>
      moment(a?.enrolledTime).unix() - moment(b?.enrolledTime).unix(),
    render: (enrolledTime) => (
      <div>
        {enrolledTime ? moment(enrolledTime).format("DD-MM-YYYY HH:MM A") : ""}
      </div>
    ),
    filters: [
      {
        text: "Blank",
        value: "0",
      },
      {
        text: "Non Blank",
        value: "1",
      },
    ],
    onFilter: (value, record) => {
      if (
        value === "0" &&
        (!record.enrolledTime || record.enrolledTime === null)
      )
        return true;
      else if (value === "1" && record.enrolledTime) {
        return true;
      }
    },
    isSelected: false,
  },
  {
    title: "Is Locked",
    dataIndex: "locked",
    key: "locked",
    render: (locked) => (
      <div className="col-5">{locked ? "true" : "false"}</div>
    ),
    filters: [
      {
        text: "Is Locked",
        value: "0",
      },
      {
        text: "Not Locked",
        value: "1",
      },
    ],
    onFilter: (value, record) => {
      if (value === "0" && record.locked) return true;
      else if (value === "1" && !record.locked) {
        return true;
      }
    },
    isSelected: true,
  },
  {
    title: "Teacher ID",
    dataIndex: "teacherId",
    key: "teacherId",
    sorter: (a, b) => a?.teacherId - b?.teacherId,
    align: "center",
    isSelected: true,
  },
  {
    title: "Device ID",
    dataIndex: "deviceId",
    key: "deviceId",
    sorter: (a, b) => a?.deviceId?.localeCompare(b?.deviceId),
    isSelected: true,
  },
  {
    title: "",
    dataIndex: "share",
    key: "share",
    fixed: "right",
    width: 50,
    align: "center",
    isSelected: true,
  },
];